import { GameLevelEnum } from '@core-http';

export const gameLevelMapper: Record<GameLevelEnum, string> = {
  [GameLevelEnum.BEGINNER]: 'Rekreacyjny',
  [GameLevelEnum.INTERMEDIATE_BEGINNER]: 'Średnio-Rekreacyjny',
  [GameLevelEnum.INTERMEDIATE]: 'Średni',
  [GameLevelEnum.ADVANCED]: 'Wysoki',
  [GameLevelEnum.PROFESSIONAL]: 'Zawodowy',
  [GameLevelEnum.MIXED]: 'Mieszany'
};

export const reversedGameLevelMapper: Record<string, GameLevelEnum> = Object.entries(gameLevelMapper).reduce(
  (acc: Record<string, GameLevelEnum>, [key, value]: [string, string]) => {
    acc[value] = GameLevelEnum[key as keyof typeof GameLevelEnum];
    return acc;
  },
  {} as Record<string, GameLevelEnum>
);
